import React from 'react';
import './header.scss';

interface HeaderProps {
  onLogout: () => void;
  onToggleHistory: () => void;
  onToggleDebug: () => void;
  currentView: 'chat' | 'history' | 'debug';
}

const Header: React.FC<HeaderProps> = ({ onLogout, onToggleHistory, onToggleDebug, currentView }) => {
  return (
    <header className="app-header">
      <div className="logo-container">
        <img src="/logo.png" alt="UTCC Logo" className="logo" />
      </div>
      <div className="header-actions">
        {/* <button className="history-toggle-button" onClick={onToggleHistory}>
          <span className="history-icon">
            {currentView !== 'history' ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"></path>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            )}
          </span>
          {currentView !== 'history' ? 'View History' : 'Back to Chat'}
        </button>
        
        <button className="debug-toggle-button" onClick={onToggleDebug}>
          <span className="debug-icon">
            {currentView !== 'debug' ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
                <path d="M12 18v.01"></path>
                <path d="M12 6a2 2 0 0 1 2 2c0 .28-.21 1.3-2 3-1.79-1.7-2-2.72-2-3a2 2 0 0 1 2-2z"></path>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            )}
          </span>
          {currentView !== 'debug' ? 'Debug' : 'Back to Chat'}
        </button> */}
        
        <button className="logout-button" onClick={onLogout}>
          <span className="logout-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </span>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
